<!--
 * @Description: 追溯查询
 * @Author: WuPuyi
 * @LastEditors: WuPuyi
 * @Date: 2020-12-02 09:34:58
 * @LastEditTime: 2020-12-08 16:15:07
-->
<template>
  <div class="trace-search">
    <!-- <h2 class="trace-search-title">追溯查询</h2> -->
    <e6-title>追溯查询</e6-title>
    <div class="trace-search-container">
      <div class="trace-search-content">
        <h3 class="trace-search-tips">请输入商品追溯码，查询追溯信息</h3>
        <div class="trace-search-input">
          <el-form ref="form" :model="form">
            <el-form-item
              :rules="[
                { required: true, message: '请输入追溯码', trigger: 'blur' },
              ]"
              prop="traceCode"
            >
              <el-input
                prefix-icon="el-icon-search"
                placeholder="追溯码"
                v-model="form.traceCode"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <el-button class="trace-search-btn" type="primary" @click="handleSearch"
          >查询</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { fetchGoodsByTagCode } from "@/api/goodsTrace/goodsTrace.js";
export default {
  data() {
    return {
      form: {
        traceCode: ""
      }
    };
  },
  methods: {
    async queryGoodsDetail() {
      try {
        let res = await fetchGoodsByTagCode({
          tagCode: this.form.traceCode
        });
        if (res.code === 1) {
          this.$router.push({
            path: "/goodsTraceWholeProcess",
            query: {
              tagCode: this.form.traceCode
            }
          });
        } else {
          this.$message.error(res.message);
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 查询
    handleSearch() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.queryGoodsDetail();
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.trace-search {
  width: 100%;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
  background-color: #edf1f6;
}
.trace-search-title {
  margin: 0;
  font-weight: normal;
  font-size: 16px;
  color: #303133;
  line-height: 30px;
}
.trace-search-container {
  background-color: #ffffff;
  width: 100%;
  height: calc(100% - 39px);
  margin-top: 10px;
  border-radius: 4px;
  box-shadow: 0px 0px 8px 0px rgba(62, 67, 244, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
  .trace-search-content {
    width: 350px;
    height: 180px;
    text-align: center;
  }
  .trace-search-tips {
    margin: 0;
    color: #606266;
    font-size: 18px;
    font-weight: normal;
    text-align: center;
  }
  .trace-search-input {
    margin: 40px 0;
    /deep/ .el-input .el-input__inner {
      height: 40px;
    }
  }
  .trace-search-btn {
    width: 160px;
    height: 40px;
    background-color: #258cff;
  }
}
</style>
